<template>
  <div>
    <div id="app" class="content-wrapper" v-cloak>
      <div class="off_canvars_overlay">

      </div>
      <div class="offcanvas_menu">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="offcanvas_menu_wrapper">
                <div class="canvas_close">
                  <a href="javascript:void(0)"><i class="fa fa-times"></i></a>
                </div>
                <div id="menu" class="text-left ">
                  <ul class="offcanvas_main_menu" style="margin-bottom: 0px !important;">
                    <li :class=" {'active':thisPagePath==item.path}" v-for="(item,index) in extendsRoutes">
<!--                      <router-link :to="item.path" v-if = "item.show == true">{{item.name}}</router-link>-->
<!--                      <a :href="'#' + item.path">{{item.name}}</a>-->
                      <a @click="goMenu(item.path)" style="cursor: pointer;">{{item.name}}</a>
                    </li>
                  </ul>
<!--                  <ul class="offcanvas_main_menu">-->
<!--                    <li class="menu-item-has-children active">-->
<!--                      <a href="#">Home</a>-->
<!--                    </li>-->
<!--                    <li class="menu-item-has-children active">-->
<!--                      <a href="about.html">Explore Gene</a>-->
<!--                    </li>-->
<!--                    <li class="menu-item-has-children active">-->
<!--                      <a href="#">Explore Data</a>-->
<!--                    </li>-->
<!--                    <li class="menu-item-has-children active">-->
<!--                      <a href="#">Upload Data</a>-->
<!--                    </li>-->
<!--                    <li class="menu-item-has-children active">-->
<!--                      <a href="#">Documention</a>-->
<!--                    </li>-->
<!--                  </ul>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="header-area">
        <div class="main-header">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="main-header-item">
<!--                  <div class="main-header-menus  d-flex justify-content-between align-items-center">-->
                  <div class="main-header-menus  d-flex align-items-center">

                    <div class="header-logo" style="width: 150px; ">
                      <img src="@/assets/images/crispr_logo.png" alt="logo" style="height: 70px;">
                    </div>

                    <div class="header-menu d-none d-lg-block"   style="text-align: center; width: 100%">
                      <ul class="offcanvas_main_menu" style="margin-bottom: 0px !important;">
                        <li :class=" {'active':thisPagePath==item.path}" v-for="(item,index) in extendsRoutes">
                                     <router-link :to="item.path" v-if = "item.show == true">{{item.name}}</router-link>
                        </li>
                      </ul>
                    </div>
<!--                    <div class="header-info d-flex align-items-center "  style="margin-left:auto;">-->
                    <div class="header-info d-flex align-items-center " style="margin-left: 20px; ">
                      <div class="toggle-btn ml-30 canvas_open d-lg-none d-block">
<!--                        <i class="fa fa-bars"></i>-->
                        <el-button size="small" type="primary" id="menuSty" plain  @click="showMenu()" icon="">Menu</el-button>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </header>
<!--      <div class="appHeader">-->
<!--        <div class="f-s-14 m-b-5 header-title p-rl">-->
<!--          <span class="activePageTitle">-->
<!--            <span :style="index >=3 ? 'float:right;':' '" :class="{'menuActive':thisPagePath==item.path}" v-for="(item,index) in extendsRoutes" v-if="item.show == true">-->
<!--                          <router-link :to="item.path">{{item.name}}</router-link>-->
<!--            </span>-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->

      <div id="wrapper">
        <div class="container-fluid" style="padding: 0px">
          <router-view :didNum="didNum" :deviceId="deviceId" @login="isLogin" @changeDevice="getDevice" v-if="isRouterAlive"></router-view>
        </div>
      </div>
    </div>
    <el-dialog
      title="Change Password"
      ref="dialog"
      v-dialogDrag
      class="f-s-15"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="30%">
      <div class="f-s-13" v-show="showError" style="text-align: center;    margin-bottom: 20px;
    color: #f00;">{{errorMessage}}
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="138px" class="demo-ruleForm">
        <el-form-item label="Original Password：" prop="oldPwd">
          <el-input v-model="ruleForm.oldPwd" autocomplete="off" show-password placeholder="use at least 6 characters and up to 15 characters."></el-input>
        </el-form-item>
        <el-form-item label="New Password：" prop="newPwd">
          <el-input type="password" v-model="ruleForm.newPwd" autocomplete="off" placeholder="use at least 6 characters and up to 15 characters."></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password：" prop="twice">
          <el-input type="password" v-model="ruleForm.twice" autocomplete="off" placeholder="use at least 6 characters and up to 15 characters."></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">Cancel</el-button>
    <el-button type="primary" @click="submitForm('ruleForm')">Save</el-button>
  </span>
  </el-dialog>
    <section>
      <div v-if="cookieFlag == false" class="stage-cookiebanner banner-1 optin stage-bottom stage-categories-type-view-preferences stage-show" aria-modal="true" data-nosnippet="true" role="dialog" aria-live="polite" aria-labelledby="stage-header-1-optin" aria-describedby="stage-message-1-optin">
        <div class="stage-header">
          <div class="stage-logo"></div>
          <div class="stage-title" id="stage-header-1-optin">Manage Cookie Consent</div>
          <div class="stage-close" tabindex="0" role="button" aria-label="close-dialog">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
          </div>
        </div>

        <div class="stage-divider stage-divider-header"></div>
        <div class="stage-body">
          <div class="stage-message" id="stage-message-1-optin"><p class="body-md-regular body-sm-regular">We use cookies to bring you the most relevant experience by remembering your preferences between your visits to our website. By clicking "Accept All," you consent to the use of ALL cookies. However, you may click on "Cookie Settings" to select the types of cookies you choose to use or avoid.</p></div>
          <!-- categories start -->
          <div class="stage-categories" :class="{showButton:savePreferenceFlag}">
            <details class="spatch_cookie stage-functional">
              <summary>
						<span class="spatch_cookie-header">
							<span class="spatch_cookie-title bordercolor_black" >Base Functional</span>
							<span class="stage-always-active">
								<span class="stage-banner-checkbox">
									<input type="checkbox" id="stage-functional-optin" data-category="spatch_functional" class="stage-consent-checkbox stage-functional" size="40" value="1">
									<label class="stage-label" for="stage-functional-optin" tabindex="0"><span class="screen-reader-text">Functional</span></label>
								</span>
                <!--								Always active							</span>-->
								Must Active							</span>
							<span class="stage-icon stage-open">
<!--								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18"><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg>-->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height="18"><path fill="#ffffff" d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"/></svg>
							</span>
						</span>
              </summary>
              <div class="stage-description ">
                <span class="stage-description-functional">Data storage that enables specific features you have used or requested, or to enable transmissions over an electronic communications network.</span>
              </div>
            </details>
            <details class="spatch_cookie stage-preferences">
              <summary>
						<span class="spatch_cookie-header">
							<span class="spatch_cookie-title">Preference Settings</span>
							<span class="stage-banner-checkbox">
								<input type="checkbox"  v-model="preferencesVal" id="stage-preferences-optin" data-category="spatch_preferences" class="stage-consent-checkbox stage-preferences" size="40" >
								<label class="stage-label" for="stage-preferences-optin" tabindex="0"><span class="screen-reader-text">Preferences</span></label>
							</span>
							<span class="stage-icon stage-open">
<!--								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18"><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg>-->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height="18"><path fill="#ffffff" d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"/></svg>
							</span>
						</span>
              </summary>
              <div class="stage-description">
                <span class="stage-description-preferences">Data that stores your choices about your experience on our website.</span>
              </div>
            </details>

            <details class="spatch_cookie stage-statistics">
              <summary>
						<span class="spatch_cookie-header">
							<span class="spatch_cookie-title">Statistic Analysis</span>
              <!--							<span class="spatch_cookie-title">Statistics</span>-->
							<span class="stage-banner-checkbox">
								<input type="checkbox" v-model="statisticsVal" id="stage-statistics-optin" data-category="spatch_statistics" class="stage-consent-checkbox stage-statistics" size="40" >
								<label class="stage-label" for="stage-statistics-optin" tabindex="0"><span class="screen-reader-text">Statistics</span></label>
							</span>
							<span class="stage-icon stage-open">
<!--								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18"><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg>-->
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height="18"><path fill="#ffffff" d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"/></svg>

							</span>
						</span>
              </summary>
              <div class="stage-description">
                <span class="stage-description-statistics">The technical storage or access that is used exclusively for statistical purposes.</span>
                <span class="stage-description-statistics-anonymous">Data storage used for compiling statistics about how people use our website. These cookies are used for us to improve our site and better understand our users' needs and preferences. They are not used to identify you.</span>
              </div>
            </details>
            <!--            <details class="spatch_cookie stage-marketing">-->
            <!--              <summary>-->
            <!--						<span class="spatch_cookie-header">-->
            <!--							<span class="spatch_cookie-title">Marketing</span>-->
            <!--							<span class="stage-banner-checkbox">-->
            <!--								<input type="checkbox" v-model="marketingVal" id="stage-marketing-optin" data-category="spatch_marketing" class="stage-consent-checkbox stage-marketing" size="40">-->
            <!--								<label class="stage-label" for="stage-marketing-optin" tabindex="0"><span class="screen-reader-text">Marketing</span></label>-->
            <!--							</span>-->
            <!--							<span class="stage-icon stage-open">-->
            <!--&lt;!&ndash;								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18"><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"></path></svg>&ndash;&gt;-->
            <!--                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" height="18"><path fill="#ffffff" d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"/></svg>-->
            <!--							</span>-->
            <!--						</span>-->
            <!--              </summary>-->
            <!--              <div class="stage-description">-->
            <!--                <span class="stage-description-marketing">Data storage used to deliver you the most relevant and targeted content (which may include commercial information regarding our professional products and services), and to better understand the customers who sustain our business. Although we use this information internally, will never sell your data to third parties or to advertisers.</span>-->
            <!--              </div>-->
            <!--            </details>-->
          </div><!-- categories end -->
        </div>

        <div class="stage-links stage-information">
          <a class="stage-link stage-manage-options cookie-statement" href="http://stage.pku-genomics.org/" data-relative_url="#stage-manage-consent-container">Manage options</a>
          <a class="stage-link stage-manage-third-parties cookie-statement" href="http://stage.pku-genomics.org/" data-relative_url="#stage-cookies-overview">Manage services</a>
          <a class="stage-link stage-manage-vendors tcf cookie-statement" href="http://stage.pku-genomics.org/" data-relative_url="#stage-tcf-wrapper">Manage vendors</a>
          <a class="stage-link stage-external stage-read-more-purposes tcf" target="_blank" rel="noopener noreferrer" href="https://cookiedatabase.org/tcf/purposes/">Read more about these purposes</a>
        </div>

        <div class="stage-divider stage-footer"></div>

        <div class="stage-buttons" style="margin-left:auto;">
          <button class="stage-btn stage-deny">Deny</button>
          <button class="stage-btn stage-view-preferences" :class="{hideButton:cookieSettingFlag}" @click="cookieSettings()">Cookie Settings</button>
          <button class="stage-btn stage-save-preferences" :class="{showButton:savePreferenceFlag}" @click="savePreferences()">Save preferences</button>
          <a class="stage-btn stage-manage-options tcf cookie-statement" href="https://stage.pku-genomics.org/" data-relative_url="#stage-manage-consent-container">Cookie Settings</a>
          <button class="stage-btn stage-accept" @click="acceptAll()">Accept All</button>
        </div>

        <div class="stage-links stage-documents">
          <a class="stage-link cookie-statement" href="http://stage.pku-genomics.org/" data-relative_url="">stage</a>
          <a class="stage-link privacy-statement" href="http://stage.pku-genomics.org/" data-relative_url="">Privacy Policy</a>
          <a class="stage-link impressum stage-hidden" href="#" data-relative_url="">{title}</a>
        </div>

      </div>
    </section>

    <footer class="footer-area bg_cover " style="background-color:rgba(0,0,0,0.6);">
      <div class="container" >
        <div class="row">
          <div class="col-lg-12">
            <div class="footer-copyright text-center" style="border: 0px;">
              <p style="color:#fff;line-height: 80px; font-size: 24px; margin-bottom: 0px ">STAGE | © Zeng Lab {{footerDate}} | Peking University</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-shape">
        <img src="@/assets/images/footer-shape.png" alt="">
      </div>
    </footer>
  </div>
</template>
<script>
import loading from './components/Loading'
import Vue from 'vue'

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {loading},
  data() {
    var checkTwice = (rule, value, callback) => {
      if (value != this.ruleForm.newPwd) {
        return callback(new Error('The new password and confirmed password input do not match!'));
      } else {
        callback();
      }
    };
    return {
      footerDate:"2025",
      id: this.$store.state.id,
      isLoading: this.$store.state.isLoading,
      sidebarNav: [],
      activePage: [],
      thisPagePath:"homepage",
      userName:"",
      titleName:"stage",
      doErrorMessage: "error",
      dialogVisible: false,

      extendsRoutes: [],
      extendsRoutes1: [],
      showNavbar: false,
      firstEnter: true,
      hoverIndex: "",
      isRouterAlive: true,
      activeIndex: 1,
      activeIndex2: 0,
      errorMessage: "",
      showError: false,
      nodeList: [],
      deviceList: [],
      nodeId: "",
      deviceId: "",
      deviceName: "",
      didNum: "",
      userType: "",
      menuIndex:0,
      menuItem: "",
      showLog: false,
      navPath: [],
      activeId: sessionStorage.getItem('activeId') || 0,
      hasChildren: true,
      activeItem: sessionStorage.getItem('activeItem') || 0,
      ruleForm: {
        oldPwd: '',
        newPwd: '',
        twice: '',
      },
      rules: {
        oldPwd: [
          {required: true, message: 'Please enter the original password', trigger: ['blur', 'change']},
          {min: 6, max: 15, message: 'use at least 6 characters and up to 15 characters.', trigger: ['blur', 'change']}
        ],
        newPwd: [
          {required: true, message: 'Please enter a new password', trigger: ['blur', 'change']},
          {min: 6, max: 15, message: 'use at least 6 characters and up to 15 characters.', trigger: ['blur', 'change']}
        ],
        twice: [
          {required: true, message: 'Enter the new password again', trigger: ['blur', 'change']},
          {validator: checkTwice, trigger: ['blur', 'change']},
        ],
      },
      cookieFlag:false,
      cookieSettingFlag:false,
      savePreferenceFlag:false,
      preferencesVal:true,
      statisticsVal:true,
      marketingVal:true,
      checkUrlPath:"/homepage,/dataset,/gene,/download,/documention,/dataset/visiumhd",
      urlPath: "/homepage"
    }
  },
  created() {
    if(this.$store.state.isLoad){
      this.getLoginMenu();
    }else{
      this.getMenu();
    }
    //存菜单
    this.$router.addRoutes(this.$router.options.routes);
    this.$store.commit("setName", localStorage.getItem('advertiser_id'))
    // this.getMenuList();
    this.$nextTick(() => {
      window.onresize = function () {
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        document.getElementsByTagName("html")[0].style.fontSize = h / 50 + "px";
      }
      // this.getDevice();
    });
    // 设置名为"username"的Cookie，有效期为7天，路径为根路径
    // this.setCookie("igoc_genomics", "genomics", 7, "/");

    // 获取名为"username"的Cookie的值
    let igocGenomics = this.getCookie("igoc_genomics");
    if(igocGenomics && igocGenomics != '' ){
      this.cookieFlag = true;
    }

    // 删除名为"username"的Cookie
    // this.deleteCookie("igoc_genomics");

  },
  computed: {
    // menuIndex() {
    //   if (localStorage.getItem("menuIndex")) {
    //     return localStorage.getItem("menuIndex");
    //   } else {
    //     return 0;
    //   }
    // },
    // menuItem() {
    //   if (localStorage.getItem("menuItem")) {
    //     return JSON.parse(localStorage.getItem("menuItem"));
    //   } else {
    //     return "";
    //   }
    // },
    doError() {
      return this.$store.state.doError;
    },
    errorAlert() {
      return this.$store.state.errorAlert;
    },
    loading(){
      return this.$store.state.isLoading;
    },
    isLoad() {
      return this.$store.state.isLoad;
    }
  },
  //获取屏幕高度
  beforeMount() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    // console.log(h, 'clientHeight');
    document.getElementsByTagName("html")[0].style.fontSize = h / 50 + "px";
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(this.$store.state.isLoad){
        this.getLoginMenu();
      }else{
        this.getMenu();
      }
    });
  },
  mounted() {
    this.$nextTick(() => {

      this.footerDate = new Date().getFullYear();
      /*---canvas menu activation---*/
      $('.canvas_open').on('click', function(){
        $('.offcanvas_menu_wrapper,.off_canvars_overlay').addClass('active')
      });

      $('.canvas_close,.off_canvars_overlay').on('click', function(){
        $('.offcanvas_menu_wrapper,.off_canvars_overlay').removeClass('active')
      });

      if (localStorage.getItem("userName")) {
        this.userName=localStorage.getItem("userName");
      } else {
        this.userName="";
      }
      if (localStorage.getItem("menuIndex")) {
        this.menuIndex=localStorage.getItem("menuIndex");
      } else {
        this.menuIndex=0;
      }
      if (localStorage.getItem("menuItem")) {
        this.menuItem=JSON.parse(localStorage.getItem("menuItem"));
      } else {
        this.menuItem="";
      }

      if(this.$route.path==='/' && localStorage.getItem('thisPage')){
        let path=localStorage.getItem('thisPage');
        this.$router.push(path);
      }else{
        localStorage.setItem('thisPage',this.$route.path);
      }
      // $("#metismenu").metisMenu();
      if(this.$store.state.isLoad){
        this.getLoginMenu();
      }else{
        this.getMenu();
      }

      this.activeIndex2 = localStorage.getItem("activeMenu");
      this.activeIndex = localStorage.getItem("activeIndex");
      let hideBtn = this.$refs.showBtn;
      let btn = this.$refs.logoOutBtn;
      let that = this;
      document.addEventListener('click', (e) => {
        if ($(e.target).attr("id") != 'hideBtn') {
          if ($(e.target).attr("id") == 'showBtn' || $(e.target).attr("id") == 'showBtnIcon') {
            this.showLog = !this.showLog;
            return;
          }
          this.showLog = false;
        }
      });
      // this.getNowFormatDate();
    });
  },
  watch: {
    doError() {
      let that = this;
      window.setTimeout(function () {
        that.$store.commit("setDoError", false);
      }, 3000)
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.showError = false;
        this.errorMessage = '';
        this.ruleForm.oldPwd = '';
        this.ruleForm.newPwd = '';
        this.ruleForm.twice = '';
      }
    },
    'ruleForm.newPwd'(newVal, oldVal) {
      this.$refs['ruleForm'].validate((valid) => {
        if (this.ruleForm.twice != this.ruleForm.newPwd) {
          return false;
        }
      });
    },
    activeIndex2(newVal, oldVal) {
      localStorage.setItem("activeMenu", newVal);
      localStorage.setItem("activeIndex", String(newVal).split("-")[0]);
    },
    isLoad(newVal, oldVal) {
      if (newVal == true) {
        this.getDevice();
        if(this.$store.state.isLoad){
          this.getLoginMenu();
        }else{
          this.getMenu();
        }
        this.activeIndex2 = 0;
        this.activeIndex = 1;
      }
    },
    sidebarNav(newVal, oldVal) {
      this.$nextTick(() => {
        $("#side-menu").metisMenu();
      })
    },
    didNum(newVal, oldVal) {
      this.$store.commit("setDidNum", newVal);
      localStorage.setItem('didNum', newVal);
    },
    deviceName(newVal, oldVal) {
      this.$store.commit("setDeviceName", newVal);
      localStorage.setItem('deviceName', newVal);
    },
    deviceId(newVal, oldVal) {
      for(let i=0;i<this.deviceList.length;i++){
        if(newVal==this.deviceList[i].id){
          this.didNum=this.deviceList[i].didNum;
          break;
        }
      }
      this.$store.commit("setDeviceId", newVal);
      localStorage.setItem('deviceId', newVal);
    },
    nodeList(newVal, oldVal) {
      this.$nextTick(() => {
        // if (localStorage.getItem('nodeId')) {
        //   this.nodeId = localStorage.getItem("nodeId");
        //   let arr = [];
        //   for (let i = 0; i < newVal.length; i++) {
        //     arr.push(newVal[i].id);
        //   }
        //   if (arr.indexOf(this.nodeId) < 0) {
        //     this.nodeId = newVal[0] && newVal[0].id || "";
        //   }
        // } else {
        //   this.nodeId = newVal[0] && newVal[0].id || "";
        // }
      })
    },
    deviceList(newVal, oldVal) {
      this.$nextTick(() => {
        if (localStorage.getItem('deviceId')) {
          this.didNum = localStorage.getItem("didNum");
          this.deviceId = localStorage.getItem("deviceId");
          this.deviceName = localStorage.getItem("deviceName");
          let arr = [];
          for (let i = 0; i < newVal.length; i++) {
            arr.push(newVal[i].id);
          }
          if (arr.indexOf(this.deviceId) < 0) {
            this.didNum = newVal[0] && newVal[0].didNum || "";
            this.deviceId = newVal[0] && newVal[0].id || "";
            this.deviceName = newVal[0] && newVal[0].name || "";
          }
        } else {
          this.didNum = newVal[0] && newVal[0].didNum || "";
          this.deviceId = newVal[0] && newVal[0].id || "";
          this.deviceName = newVal[0] && newVal[0].name || "";
          localStorage.setItem("didNum",this.didNum);
          localStorage.setItem("deviceId",this.deviceId);
          localStorage.setItem("deviceName",this.deviceName);
        }
      })
    },
    $route(to, from) {
      this.$nextTick(()=>{
        this.thisPagePath=this.$route.path;
        // let path = this.$route.path;
        let path ;
        if(from.name){
          path = this.$route.path;
        }else {
          path = this.urlPath;
          this.$router.push(path);
        }

        if(this.thisPagePath.indexOf("userPortrait") > 0){
          this.titleName = "STAGE";
        }else {
          this.titleName = "STAGE";
        }
        let allPath = this.thisPagePath;

        if(!this.checkUrlPath.split(",").includes(allPath)){
          this.thisPagePath = '/homepage';
          path = '/homepage';
          this.$router.push('/homepage');
        }else{
          if(this.thisPagePath.indexOf("dataset") > 0){
            this.thisPagePath = "/dataset";
          }
        }

        this.activePage.splice(0, this.activePage.length);
        this.userName = localStorage.getItem("userName") || "";
        let arr = this.extendsRoutes;
        let activePath = false;//判断当前页面是否在菜单数据中
        if(path.indexOf("dataset") > 0){
          path = "/dataset";
        }

        for (let i = 0; i < arr.length; i++) {
          //一级标题
          if (arr[i].path.indexOf(path) != -1) {
            activePath = true;
            this.activePage.push({name: arr[i].name, path: arr[i].path,});
            //监听路由变化改变菜单active
            // this.activeIndex2 = arr[i].index;
            this.activeIndex2 = i;
          } else {
            // 二级标题
            let arr1 = arr[i].child?arr[i].child:[];
            for (let j = 0; j < arr1.length; j++) {
              // if (arr1[j].path == path) {
              if (arr1[j].path.indexOf(path) != -1) {
                activePath = true;
                this.activePage.push({name: arr[i].name, path: arr[i].path,});
                this.activePage.push({name: arr1[j].name, path: arr1[j].path,});
                //监听路由变化改变菜单active
                this.activeIndex2 = arr1[j].index;
              } else {
                //三级标题
                let arr2 = arr1[j].child?arr1[j].child:[];
                for (let k = 0; k < arr2.length; k++) {
                  // if (arr2[k].path == path) {
                  if (arr2[k].path.indexOf(path) != -1) {
                    activePath = true;
                    this.activePage.push({name: arr[i].name, path: arr[i].path,});
                    this.activePage.push({name: arr1[j].name, path: arr1[j].path,});
                    this.activePage.push({name: arr2[k].name, path: arr2[k].path,});
                    //监听路由变化改变菜单active
                    this.activeIndex2 = arr2[k].index;
                    //选中二级菜单
                    this.thisPagePath = arr1[j].path;
                  }
                }
              }
            }
          }
        }
        //新菜单
        for(let i=0;i<arr.length;i++){
          if(this.$route.path==arr[i].path){
            this.menuIndex=i;
            this.menuItem=arr[i];
            localStorage.setItem("menuIndex",i);
            localStorage.setItem("menuItem",JSON.stringify(arr[i]));
          }else{
            // alert(2);
            let child=arr[i].child || [];
            for(let j=0;j<child.length;j++){
              if(this.$route.path==child[j].path){
                this.menuIndex=i;
                this.menuItem=arr[i];
                localStorage.setItem("menuIndex",i);
                localStorage.setItem("menuItem",JSON.stringify(arr[i]));
              }
            }
          }
        }
        // console.log(path,activePath,'path');
        let firstEnter = this.$router.query && this.$router.query.name || '';
        // console.log(firstEnter,'firstEnte 11r');
        if (this.$route.path !== '/') {
          localStorage.setItem('thisPage', this.$route.path);
        }
        if (localStorage.getItem("menuIndex")) {
          this.menuIndex=localStorage.getItem("menuIndex");
        } else {
          this.menuIndex=0;
        }
        if (localStorage.getItem("menuItem")) {
          this.menuItem=JSON.parse(localStorage.getItem("menuItem"));
        } else {
          this.menuItem="";
        }

        if(!activePath && path!='/screen2' && path!='/login' && !firstEnter){
          this.$router.push('/homepage');
        }
      })
    },
    extendsRoutes(newVal, oldVal) {
      var fullPath = window.location.href;
      if(fullPath.indexOf("#") > 0){
        let routePath = fullPath.split("#")[1];
        let routePath1 = routePath;
        if(routePath.indexOf("?") > 0){
          routePath1 = routePath.split("?")[0]
        }

        if(this.checkUrlPath.split(",").includes(routePath1)){
          this.urlPath = routePath;
        }else{
          this.urlPath = '/homepage';
        }
      }


      // this.$nextTick(() => {
      //   console.log(this.thisPagePath);
      //   console.log(this.$route.path);
      //   this.activePage.splice(0, this.activePage.length);
      //   let path = this.$route.path;
      //   let arr = newVal;
      //   for (let i = 0; i < arr.length; i++) {
      //     //一级标题
      //     if (arr[i].path == path) {
      //       this.activePage.push({name: arr[i].name, path: arr[i].path,});
      //       //监听路由变化改变菜单active
      //       this.activeIndex2 = i;
      //     } else {
      //       // 二级标题
      //       let arr1 = arr[i].child?arr[i].child:[];
      //       if(arr1 && arr1.length > 0){
      //         for (let j = 0; j < arr1.length; j++) {
      //           if (arr1[j].path == path) {
      //             this.activePage.push({name: arr[i].name, path: arr[i].path,});
      //             this.activePage.push({name: arr1[j].name, path: arr1[j].path,});
      //             //监听路由变化改变菜单active
      //             this.activeIndex2 = arr1[j].index;
      //           } else {
      //             //三级标题
      //             let arr2 = arr1[j].child?arr1[j].child:[];
      //             for (let k = 0; k < arr2.length; k++) {
      //               if (arr2[k].path == path) {
      //                 this.activePage.push({name: arr[i].name, path: arr[i].path,});
      //                 this.activePage.push({name: arr1[j].name, path: arr1[j].path,});
      //                 this.activePage.push({name: arr2[k].name, path: arr2[k].path,});
      //                 //监听路由变化改变菜单active
      //                 this.activeIndex2 = arr2[k].index;
      //               }
      //             }
      //           }
      //         }
      //       }
      //
      //     }
      //   }
      // })
    },
  },
  methods: {
    showMenu(){
      /*---canvas menu activation---*/
      $('.canvas_open').on('click', function(){
        $('.offcanvas_menu_wrapper,.off_canvars_overlay').addClass('active')
      });

      $('.canvas_close,.off_canvars_overlay').on('click', function(){
        $('.offcanvas_menu_wrapper,.off_canvars_overlay').removeClass('active')
      });
    },
    goMenu(path){
      this.$router.push(path);
      $('.offcanvas_menu_wrapper,.off_canvars_overlay').removeClass('active')
    },
    changeMenu(item, index) {
      if(this.menuIndex==index){
        return;
      }
      this.menuIndex = index;
      this.menuItem = item;
      let activePath=item.child.length && item.child[0].path || item.path;
      this.thisPagePath=activePath;
      this.$router.push(activePath);
      // console.log(this.menuItem, 'index');
      localStorage.setItem("menuIndex", index);
      localStorage.setItem("menuItem", JSON.stringify(item));
    },
    goBigcreen(){
      this.$router.push('/screen3/topoScreen');
    },
    changeErrorStatus(status) {
      this.doError = true;
      this.errorAlert = status;
    },
    getMenu() {
      let _this = this;
      // console.log(this.activeIndex2, 'index2');
      this.extendsRoutes.splice(0, _this.extendsRoutes.length);
      // let url = this.$store.state.port + "/sysAuth/index.do";
      // this.$axios.get(url).then(response => {
      //   if (response && response.data.code == 0) {
      //     // let data = response && response.data.data || [];
      //     // if(data.length<1){
      //     //   this.$router.push('/noAuth');
      //     //   return;
      //     // }
      //     // let data=[{"id":19,"name":"网络管理","parentId":-1,"path":null,"icon":null,"sysType":null,"resType":null,"sort":null,"child":[{"id":20,"name":"设备管理","parentId":19,"path":"/device","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":21,"name":"链路管理","parentId":19,"path":"/net4","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":22,"name":"用户管理","parentId":19,"path":"/net2","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":23,"name":"业务管理","parentId":19,"path":"/net3","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":24,"name":"时间管理","parentId":19,"path":"/time","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]}]},{"id":25,"name":"事件管理","parentId":-1,"path":null,"icon":null,"sysType":null,"resType":null,"sort":null,"child":[{"id":26,"name":"DDOS防护","parentId":25,"path":"/ddos","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":27,"name":"告警配置","parentId":25,"path":"/alarmMsg","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":28,"name":"管道告警","parentId":25,"path":"/channelAlarm","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":29,"name":"时延告警","parentId":25,"path":"/delayAlarm","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":30,"name":"DDOS告警","parentId":25,"path":"/ddosAlarm","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]}]},{"id":31,"name":"系统管理","parentId":-1,"path":null,"icon":null,"sysType":null,"resType":null,"sort":null,"child":[{"id":32,"name":"节点管理","parentId":31,"path":"/nodePoint","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":33,"name":"用户管理","parentId":31,"path":"/user","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":34,"name":"用户组管理","parentId":31,"path":"/userGroup","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":35,"name":"数据备份","parentId":31,"path":"/backups","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":36,"name":"指令任务","parentId":31,"path":"/execute","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":37,"name":"日志管理","parentId":31,"path":"/log","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":38,"name":"IP管理","parentId":31,"path":"/ipList","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]}]},{"id":1,"name":"首页","parentId":-1,"path":"/dashboard","icon":null,"sysType":null,"resType":null,"sort":1,"child":[]},{"id":2,"name":"网络监控","parentId":-1,"path":"","icon":null,"sysType":null,"resType":null,"sort":1,"child":[{"id":3,"name":"链路监控","parentId":2,"path":"/monitor2","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":4,"name":"业务监控","parentId":2,"path":"/monitor4","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":5,"name":"用户监控","parentId":2,"path":"/monitor3","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]}]},{"id":6,"name":"历史统计","parentId":-1,"path":null,"icon":null,"sysType":null,"resType":null,"sort":1,"child":[{"id":7,"name":"链路统计","parentId":6,"path":"/link","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":8,"name":"业务统计","parentId":6,"path":"/service","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":9,"name":"用户统计","parentId":6,"path":"/party","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":10,"name":"全网统计","parentId":6,"path":"/monitor","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":11,"name":"域名统计","parentId":6,"path":null,"icon":null,"sysType":null,"resType":null,"sort":2,"child":[]}]},{"id":12,"name":"网络优化","parentId":-1,"path":null,"icon":null,"sysType":null,"resType":null,"sort":1,"child":[{"id":18,"name":"策略管控","parentId":12,"path":"/policy","icon":null,"sysType":null,"resType":null,"sort":null,"child":[]},{"id":13,"name":"管道管理","parentId":12,"path":"/channel","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":14,"name":"一键优化","parentId":12,"path":"/optimize","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":15,"name":"批量部署","parentId":12,"path":"/batch","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]},{"id":16,"name":"实时评估","parentId":12,"path":"/assess","icon":null,"sysType":null,"resType":null,"sort":2,"child":[]}]}];
      //     // for (let i = 0; i < data.length; i++) {
      //     //   data[i].index = (i + 1);
      //     //   let arr2 = data[i].child;
      //     //   let n = 0;
      //     //   for (let j = 0; j < arr2.length; j++) {
      //     //     let arr3 = arr2[j].child;
      //     //     if (arr3.length > 0) {
      //     //       for (let k = 0; k < arr3.length; k++) {
      //     //         n++;
      //     //         arr3[k].index = (i + 1) + "-" + n;
      //     //       }
      //     //     } else {
      //     //       arr2[j].index = (i + 1) + '-' + (j + 1);
      //     //     }
      //     //   }
      //     // }
      //     // this.extendsRoutes = data;
      //     // console.log(this.extendsRoutes, 'data');
      //     //动态添加路由
      //     // for(let i=0;i<this.extendsRoutes.length;i++){
      //     //   if(this.extendsRoutes[i].child.length>0){
      //     //     let arr=this.extendsRoutes[i].child;
      //     //     for(let i=0;i<arr.length;i++){
      //     //       this.$router.options.routes.push(arr[i]);
      //     //     }
      //     //   }else{
      //     //     this.$router.options.routes.push(this.extendsRoutes[i]);
      //     //   }
      //     // }
      //     sessionStorage.setItem('menus', JSON.stringify(this.extendsRoutes));
      //     console.log(this.extendsRoutes, 'menu');
      //     this.$router.push('/nodePoint');
      //
      //     // 存菜单
      //     sessionStorage.setItem('menus', JSON.stringify(this.extendsRoutes));
      //   }
      // }).catch(e => {
      //
      // })

      // sessionStorage.setItem('menus', JSON.stringify(this.extendsRoutes));

      // this.$router.push('/login');
      this.extendsRoutes = [
        {path: '/homepage',name:'Home',index:'1',show:true,meta:{name: 'Home'}},
        {path: '/gene',name:'Gene',index:'9',show:true,meta:{name: 'Gene'}},
        {path: '/dataset',name:'Dataset',index:'2',show:true,meta:{name: 'Dataset'},
          child:[
            {path: '/visiumhd',name:'Visiumhd',index:'5',show:true,meta:{name: 'Visiumhd'}},
          ]
        },
        {path: '/download',name:'Download',index:'3',show:true,meta:{name: 'Download'}},
        {path: '/documention',name:'Documentation',index:'4',show:true,meta:{name: 'Documentation'}},
        // {path: '/internaldata',name:'Internal Data',index:'6',show:false,meta:{name: 'Internal Data'}},

      ]
      // 存菜单
      sessionStorage.setItem('menus', JSON.stringify(this.extendsRoutes));
      // console.log(this.extendsRoutes, 'menu');
      this.$router.push('/homepage');

    },
    getLoginMenu() {
      let _this = this;
      // console.log(this.activeIndex2, 'index2');
      this.extendsRoutes.splice(0, _this.extendsRoutes.length);

      this.extendsRoutes = [
        {path: '/homepage',name:'Home',index:'1',show:true,meta:{name: 'Home'}},
        {path: '/dataset',name:'Dataset',index:'2',show:true,meta:{name: 'Dataset'}},
        {path: '/gene',name:'Gene',index:'9',show:true,meta:{name: 'Gene'}},
        {path: '/download',name:'Download',index:'3',show:true,meta:{name: 'Download'}},
        {path: '/documention',name:'Documentation',index:'4',show:true,meta:{name: 'Documentation'}},

      ]
      // 存菜单
      sessionStorage.setItem('menus', JSON.stringify(this.extendsRoutes));
      // console.log(this.extendsRoutes, 'menu');
      // this.$router.push('/login');

    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    sendId(id) {
      // console.log(id);
    },
    getNode() {
      //获取所有子网
      let url = this.$store.state.port + "/networkNode/getAll.do";
      this.$axios.get(url).then(response => {
        this.nodeList = response.data || [];
        if (localStorage.getItem('nodeId')) {
          this.nodeId = localStorage.getItem("nodeId");
        }
        let flag = false;
        for (let i = 0; i < this.nodeList.length; i++) {
          if (this.nodeId == this.nodeList[i].id) {
            flag = true;
            break;
          }
        }
        // if (!flag) {
        //   this.nodeId = this.nodeList[0].id;
        //   localStorage.setItem("nodeId", this.nodeId);
        // }
      }).catch(e => {
        this.nodeList = [];
      })
    },
    getDevice() {
      //获取所有子网
      let url = this.$store.state.port + "/device/getAllByUser.do";
      this.$axios.get(url).then(response => {
        if (response && response.data.code == 0) {
          this.deviceList = response.data.data || [];
        } else {
          this.deviceList = [];
        }
        if (localStorage.getItem('deviceId')) {
          this.deviceId = localStorage.getItem("deviceId");
          this.deviceName = localStorage.getItem("deviceName");
        }
        if (localStorage.getItem('didNum')) {
          this.didNum = localStorage.getItem("didNum");
        }
        let flag = false;
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceId == this.deviceList[i].id) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.didNum = this.deviceList[0].didNum;
          this.deviceId = this.deviceList[0].id;
          this.deviceName = this.deviceList[0].name;
          localStorage.setItem("didNum", this.didNum);
          localStorage.setItem("deviceId", this.deviceId);
          localStorage.setItem("deviceName", this.deviceName);
        }
      }).catch(e => {
        this.deviceList = [];
        this.deviceId = "";
        this.deviceName = "";
        this.didNum = "";
        localStorage.removeItem("didNum");
        localStorage.removeItem("deviceId");
        localStorage.removeItem("deviceName");
      })
    },
    showBtn() {
      // this.showLog = !this.showLog;
    },
    handleCommand(command) {
      if (command == 'a') {
        this.logOut();
      }
    },
    handleSelect(key, keyPath) {
      this.activeIndex2 = key;
      localStorage.setItem("activeMenu", key);
    },
    search() {
      this.queryData();
    },
    queryData() {
      // console.log("搜索");
    },
    toggleNavbar() {
      $("#example-navbar-collapse").slideToggle()
      // this.showNavbar=!this.showNavbar
    },
    menuClick: function (item, subIndex, index) {
      if (subIndex != 'index') {
        this.activeId = parseInt(index);
        this.activeItem = parseInt(subIndex);
        this.hasChildren = true;
      } else {
        this.activeId = index;
        this.activeItem = null;
        this.hasChildren = false;
      }
      sessionStorage.setItem('activeId', this.activeId)
      sessionStorage.setItem('activeItem', this.activeItem)
      if (this.$route.path == item.url) {
        return;
      } else {
        this.$router.push(item.url);
      }
    },
    isLogin() {
      this.activeIndex2 = localStorage.getItem("activeMenu");
      this.getLoginMenu();
    },
    getMenuList: function () {

    },
    changePwd() {
      this.dialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = this.$store.state.port + "/sys/updatePwd";
          let data = {
            userId:localStorage.getItem("userId"),
            newPwd: this.$md5(this.ruleForm.newPwd),
            oldPwd: this.$md5(this.ruleForm.oldPwd),
          };
          this.$axios.post(url, this.$qs.stringify(data)).then(response => {
            console.log(response);
            if (response.data.status == 600200) {
              this.showError = false;
              this.errorMessage = "";
              this.dialogVisible = false;
              this.$router.push('/login');
            }else{
              this.showError = true;
              this.errorMessage = response.data.msg;
              this.dialogVisible = true;
              return;
            }

          }).catch(e => {
            this.showError = true;
            this.errorMessage = "failes！";
            this.dialogVisible = true;
          });
        } else {
          return false;
        }
      });
    },
    logOut() {
      //测试
      this.showLog = false;
      this.$store.commit("setStatus", true);
      // let userId = this.$store.state.userId;
      let userId = localStorage.getItem("userId");
      // console.log(this.$store.state.isLoading, 1);
      let url = this.$store.state.port + "/sys/logout";
      this.$axios.get(url).then(response => {
        if(response.data.status === 600200){
          this.$store.commit("setStatus", false);
          // console.log(this.$store.state.isLoading, 2);
          // let arr = document.cookie.split(";");
          // let exp = new Date();
          // exp.setTime(exp.getTime() + (-1 * 24 * 60 * 60 * 1000));
          // document.cookie = "advertiser_id=1;expires=" + exp.toGMTString();
          this.$store.commit("setStatus", false);
          localStorage.removeItem("user");
          localStorage.removeItem("userName");
          localStorage.removeItem("passWord");
          localStorage.removeItem("user");
          localStorage.removeItem("userId");
          localStorage.removeItem("token");
          localStorage.removeItem("advertiser_id");

          // localStorage.setItem("didNum", "");
          // localStorage.setItem("deviceId", "");
          // localStorage.setItem("deviceName", "");
          this.$store.commit("setIsLoad", false);
          this.getMenu();
          this.$router.push('/homepage');
          // console.log(this.$store,'store')
        }else {
          alert("Exit failed！");
          // this.$router.push('/homepage');
        }

      }).catch(error => {
        this.$store.commit("setStatus", false);
      })
    },
    sendLogin(){
      this.$router.push('/login');
    },
    acceptAll(){
      var dateTime = new Date().getTime();
      var cookieVal = "preferencesVal=true;statisticsVal=true;marketingVal=true" + ";dateTime=" + dateTime;
      this.setCookie("igoc_genomics", cookieVal, 7, "/");
      //TODO保存cookie
      this.cookieFlag = true;
      this.saveCookie(cookieVal);
    },
    cookieSettings(event){
      this.cookieSettingFlag = true;
      this.savePreferenceFlag = true;
    },
    savePreferences(){
      var dateTime = new Date().getTime();
      let cookieVal = "preferencesVal=" + this.preferencesVal + ";statisticsVal=" + this.statisticsVal + ";marketingVal=" + this.marketingVal + ";dateTime=" + dateTime;
      this.setCookie("igoc_genomics", cookieVal, 7, "/");
      this.cookieFlag = true;
      this.cookieSettingFlag = false;
      this.savePreferenceFlag = false;
      this.saveCookie(cookieVal);
    },
    saveCookie(cookieVal){
      let url = this.$store.state.port + "/sys/saveCookie";
      let data = {
        cookieStr:cookieVal
      };
      this.$axios.post(url, this.$qs.stringify(data)).then(response => {
        if (response.data.status == 600200) {

        }else{
          return;
        }

      }).catch(e => {
        console.log(e);
      });
    },
    setCookie(name, value, expires, path, domain, secure) {
      let cookieString = name + "=" + encodeURIComponent(value);
      if (expires) {
        let expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + expires * 24 * 60 * 60 * 1000);
        cookieString += "; expires=" + expirationDate.toUTCString();
      }
      if (path) {
        cookieString += "; path=" + path;
      }
      if (domain) {
        cookieString += "; domain=" + domain;
      }
      if (secure) {
        cookieString += "; secure";
      }
      document.cookie = cookieString;
    },
    getCookie(name) {
        let cookieName = name + "=";
        let cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i].trim();

          if (cookie.indexOf(cookieName) === 0) {
            return decodeURIComponent(cookie.substring(cookieName.length));
          }
        }
        return null;
    },
    deleteCookie(name, path, domain) {
       if (this.getCookie(name)) {
          document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
        }

        if (path) {
          document.cookie = name + "=; path=" + path;
        }

        if (domain) {
          document.cookie = name + "=; domain=" + domain;
        }
    }


}
}
</script>
<style lang="less" type="text/less">
.updatePage {
  margin-left: 0.6rem;
  height: 3rem;
  div {
    height: 1.8rem;
    margin-top: 0.6rem;
    line-height: 1.8rem;
    margin-left: 0 !important;
    padding: 0 0.8rem;
  }
}

.titleLine {
  width: 1px;
  height: 3rem;
  background: #4D5C73;
}

.header-title {
  /*z-index: 2;*/
}

.alertTitleDiv {
  position: absolute;
  left: 50%;
  top: 116%;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, 0%);
  min-width: 50px;
  background: #fff;
  padding: 3px 8px;
  font-size: 12px !important;
  box-shadow: 0 0 3px rgba(197, 197, 197, 0.6);
  .icon-quxiao1 {
    color: #e41610;
  }
  .icon-zhengque {
    color: #2ebd12;
  }
}

.close-icon-up {
  display: inline-block;
  transition: all linear 0.2s;
}

.close-icon-drop {
  transform: rotate(-180deg);
}
.activePageTitle {
  color: #152D40;
  span {
    padding: 0px 10px 0px 10px;
    font-size: 12px;
    float: left;
    position: relative;
    margin: 0px 10px 0px 10px;
    //background: url("./assets/menuBg.png") no-repeat;
    background: #152D40;
    background-size: 100% 100%;
    a{
      color: #fff;
      padding: 0px 5px 0px 5px;
    }
    border: 1px solid #1C465E;
  }

  span:first-child{
    margin-left: 0;
  }
  .menuActive{
    color: #fff;
    background: #204B68;
    //background: url("./assets/menuBgActive.png") no-repeat;
    background-size: 100% 100%;
    a{
      color: #fff;
    }
  }
}
@media screen and (max-width: 1300px){
  .activePageTitle {
    color: #000;
    span {
      /*padding: 2px 0px 2px 10px;*/
    }
  }
}
.menu2 {
  .iconfont {
    font-size: inherit;
    color: inherit;
    vertical-align: unset;
  }
}

.activePageTitle {
  color: #8fa0ac;
  span {
    span {
      color: #50646f;
      .el-icon {
        font-size: 13px !important;
        margin: 0 4px;
      }
    }
  }
  span:last-child {
    color: #50646f;
  }
}

//自定义菜单
.menu2 {
  .menuTitleBak {
    color: #fff;
    padding: 0 20px;
    font-size: 14px;
    line-height: 23px !important;
  }
}

.myMenu {
  float: left;
  height: 100%;
  width: auto;
  .firstMenu {
    float: left;
    height: 100%;
    text-align: center;
    line-height: 60px;
    width: auto;
    min-width: 80px;
    color: #fff;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    font-size: 16px;
    position: relative;
    margin: 0 8px;
    .secondMenu {
      background: #1d2b36;
      color: #fff;
      cursor: pointer;
      display: none;
      padding: 7px 4px;
      position: absolute;
      top: 60px;
      left: 50%;
      width: 140px;
      margin-left: -70px;
      z-index: 999999;
      .thirdMenu {
        float: left;
        width: 65px;
        .thirdMenuTitle {
          height: 36px;
          line-height: 36px;
          font-size: 15px;
          color: #fff;
        }
        .thirdMenuItem {
          height: 36px;
          line-height: 36px;
          font-size: 13px;
          color: #ABB6BC;
          a {
            display: block;
            width: 100%;
            height: 100%;
            color: #ABB6BC;
          }
        }
        .thirdMenuItem:hover {
          a {
            color: #409EFF;
          }
        }
      }
    }
  }
  .firstMenu:hover {
    border-bottom-color: #409EFF;
    color: #409eff;
    .secondMenu {
      display: block;
    }
  }
}

#mainPage .headerSearch::placeholder {
  color: #CACDCF !important;
  font-size: 12px;
}

#mainPage .headerSearch::-webkit-input-placeholder {
  color: #CACDCF !important;
  font-size: 12px;
}

#mainPage .headerSearch::-moz-placeholder {
  font-size: 12px;
  color: #CACDCF !important;
  opacity: 1;
}

#mainPage .headerSearch:-ms-input-placeholder {
  font-size: 12px;
}

.logout {
  position: absolute;
  top: 1.3rem;
  //left: 0;
  right: 0;
  //background: #1d2b36;
  color: #fff;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  font-size: 13px;
  width: 120px;
}

.logout:hover {
  color: #409efe;
}

.router-view {
  position: absolute;
  left: 230px;
  top: 60px;
}

.msg {
  position: relative;
  left: 0;
  user-select: none;
  font-size: 16px;
  span {
    position: absolute;
    top: 1px;
    right: -2px;
    width: 4px;
    height: 4px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #ED5D01;
  }
}

@media screen and (max-width: 1600px) {
  .msg {
    font-size: 15px;
  }

  .header-text {
    font-size: 13px !important;
  }
}

@media screen and (max-width: 1400px) {
  .msg {
    font-size: 13px;
  }

  .header-text {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 1268px) {
  .msg {
    font-size: 12px;
  }

  .header-text {
    font-size: 12px !important;
  }
}

.appHeader {
  //background: #1d2b36;
  text-align: center;
  box-sizing: border-box;
  height: 5.9rem !important;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 6666666;
  min-width: 900px;
  .header-right {
    float: right;
    height: 100%;
    display: flex;
    color: #CACDCF;
    min-width: 5rem;
    .pull-left {
      margin-left: 0.6rem;
    }
    @media screen and(max-width: 1600px) {
      .pull-left {
        /*margin-left: 5px;*/
      }
    }
    .user {
      font-size: 0.5rem;
      cursor: pointer;
      min-width: 80px;
      text-align: center;
      height: 3rem;
      line-height: 3rem;
      i {
        font-size: 12px;
      }
      margin-right: 0.5rem;
    }
    align-items: center;
    .input {
      div {
        right: 3px;
        top: 0px;
        color: #fff;
        line-height: 1.8rem;
        position: absolute;
        i {
          padding: 0 7px;
          border-left: 1px solid #ddd;
          border-color: #505E67;
          cursor: pointer;
        }
      }
      position: relative;
      input {
        background: rgb(55, 69, 78);
        padding: 5px 8px;
        border: none;
        outline: none;
        display: inline-block;
        height: 1.8rem;
        color: #fff;
        padding-right: 50px;
        width: 202px;
      }
      @media screen and(max-width: 1400px) {
        input {
          width: 145px;
        }
      }
    }
  }
}

.header {
  float: left;
  position: relative;
  z-index: 6;
  padding: 0px 7px;
  overflow: hidden;
  margin-right: 1rem;
  div {
    .header-text {
      height: 25px;
      font-size: 14px;
      line-height: 25px;
      color: #E9E9EC;
      display: inline-block;
      width: 100%;
      font-family: "SimHei";
    }
    height: 3rem;
    line-height: 3rem;
    float: left;
    .line {
      height: 1rem;
      display: inline-block;
      background: #6674A4;
      margin: 1rem 10px;
      width: 2px;
    }
    img {
      height: 63%;
      width: auto;
    }
  }
}

@media screen and (max-width: 1600px) {
  .header div {
    img {
      height: 60% !important;
      width: auto;
    }
  }
}

@media screen and (max-width: 1300px) {
  .header div {
    img {
      height: 60% !important;
      width: auto;
    }
  }

  .header {
    margin-right: 0.5rem;
  }
}

@media screen and (max-width: 1100px) {
  .header div {
    img {
      height: 55% !important;
      width: auto;
    }
  }

  .header {
    margin-right: 0;
  }
}

@media screen and (max-device-width: 1600px) {
  .appHeader {
    //background: #1d2b36;
    height: 8rem !important;
  }
  .nowTime{
    left: 200px;
  }
  .fightTime{
    right: 207px;
  }

}

@media screen and (max-width: 1000px) {
  .header div {
    img {
      height: 50% !important;
      width: auto;
    }
  }

  .header {
    margin-right: 0;
  }
}

.bg-title {
  background: #ffffff;
  overflow: hidden;
  padding: 15px 15px 10px;
  margin-bottom: 25px;
  .breadcrumb {
    background: none;
    margin-bottom: 0px;
    float: right;
    padding: 0;
    margin-top: 8px;
    a {
      color: rgba(0, 0, 0, 0.5);
    }
    .active {
      color: #f75b36;
    }
  }
}

.main-header .main-header-item .header-menu ul li:hover > a{
  //color: #5e72e4 !important;
  //color: #007bff !important;
  color: #41CFFF !important;
}
.main-header .main-header-item .header-menu ul .active  > a{
  //color: #007bff !important;
  color: #41CFFF !important;

}

.show-login:hover .login-show{
  display: block;
}
.login-show{
  display: none;
}

.el-dialog__header{
  background: #f2f2f2 !important;
}
.el-form-item__label{
  padding:0px;
}
.el-dialog__body{
  padding:30px 40px 30px 20px;
}

.cookies_banner{
  position: fixed;
  z-index: 999999;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 24px 21px;
  background-color: #000;
  border: 1px solid hsla(0,0%,100%,.24);
  color: #ccc;
  font: 12px/16px JetBrains Mono Regular,Menlo,Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New,monospace,serif;
  opacity: 1;
  transition: opacity .3s;
}

.hideButton{
  display: none !important;
}
.showButton{
  display: block !important;
}
.bordercolor_black{
  border-color:black !important;
}

#menuSty{
  font-size: 20px;
  color:#838694;
}

#menuSty:hover, #menuSty:focus{
  color:#007bff !important;
  background: #ced4da !important;
  border-color: #ced4da !important;
}

//.el-button--primary.is-plain #menuSty:focus , .el-button--primary.is-plain #menuSty:hover{
//  color:#007bff !important;
//  background: #ced4da !important;
//  border-color: #ced4da !important;
//}
</style>



// WEBPACK FOOTER //
// src/App.vue